export const CRISIS_MANAGER = {
  TITLE: 'Crisis Manager',
  TABS: {
    COMMITEE: 'Commitee',
    INCIDENTS: 'Incidents',
  },
  ESCALATION_ORDER: {
    TITLE: 'Escalation Order',
  },
  CONTACT_GROUPS: {
    COMMITTEE: {
      TITLE: 'Commitee',
      BADGE: 'Commitee',
    },
    QALEA: {
      TITLE: 'Qalea',
      BADGE: 'MSSP',
    },
    ADD_BUTTON: 'Add',
  },
  CONTACT_ITEM: {
    BADGES: {
      COMMITTEE: 'Committee',
      MSSP: 'MSSP',
    },
    ALERT_BUTTON: 'Alert',
  },
  CONTACT_FORM: {
    ADD: {
      TITLE: 'Add New Contact',
      DESCRIPTION: 'Add a new member to the crisis management committee.',
    },
    EDIT: {
      TITLE: 'Edit Contact',
      DESCRIPTION: 'Update the contact information.',
    },
    FIELDS: {
      NAME: {
        LABEL: 'Name',
        REQUIRED: '*',
      },
      TITLE: {
        LABEL: 'Title',
        REQUIRED: '*',
      },
      PHONE: {
        LABEL: 'Phone',
        REQUIRED: '*',
      },
      EMAIL: {
        LABEL: 'Email',
        REQUIRED: '*',
      },
      ON_CALL_HOURS: {
        LABEL: 'On-Call Hours',
        REQUIRED: '*',
      },
    },
    ACTIONS: {
      SAVE: 'Save Changes',
      ADD: 'Add Contact',
      CANCEL: 'Cancel',
    },
  },
  DELETE_DIALOG: {
    TITLE: 'Delete Contact',
    DESCRIPTION: (contactName: string) =>
      `Are you sure you want to delete <strong>${contactName}</strong> from the committee? This action cannot be undone.`,
    ACTIONS: {
      CANCEL: 'Cancel',
      DELETE: 'Delete',
    },
  },
  ALERT_DIALOG: {
    TITLE: 'Alert Contact',
    DESCRIPTION: 'Escalate alert to:',
    WARNING: 'The contact will be notified immediately.',
    SUCCESS: (contactName: string) => `Alert escalated to ${contactName}`,
    ACTIONS: {
      CANCEL: 'Cancel',
      CONFIRM: 'Confirm Alert',
    },
  },
  INCIBE_FORM: {
    TITLE: 'INCIBE-CERT Notification',
    PREVIEW_TITLE: 'Email Preview - INCIBE-CERT Notification',
    PREVIEW_DESCRIPTION: 'Review the incident report details before sending',
    FIELDS: {
      EMAIL: {
        LABEL: 'Your Email Address',
        PLACEHOLDER: 'you@company.com',
        DESCRIPTION: 'This address will be used as the sender in the email',
        REQUIRED: '*',
      },
      CLASSIFICATION: {
        LABEL: 'Incident Classification',
        PLACEHOLDER: 'Select classification...',
        REQUIRED: '*',
      },
      INCIDENT_TYPE: {
        LABEL: 'Incident Type',
        PLACEHOLDER: 'Select type...',
        REQUIRED: '*',
      },
      SECTOR: {
        LABEL: 'Sector',
        PLACEHOLDER: 'E.g.: Financial, Healthcare, Technology, etc.',
        REQUIRED: '*',
      },
      DESCRIPTION: {
        LABEL: 'Incident Description',
        PLACEHOLDER: 'Detailed description of the incident...',
        REQUIRED: '*',
      },
      AFFECTED_SYSTEMS: {
        LABEL: 'Affected Systems',
        PLACEHOLDER: 'List of affected systems, servers or resources...',
      },
      ATTACK_VECTOR: {
        LABEL: 'Attack Vector',
        PLACEHOLDER: 'E.g.: Phishing, Exploit, Brute force, etc.',
      },
      IMPACT: {
        LABEL: 'Impact',
        PLACEHOLDER: 'Description of the impact on the organization...',
      },
      IOCS: {
        LABEL: 'Indicators of Compromise (IOCs)',
        PLACEHOLDER: 'IPs, domains, hashes, URLs, etc.',
      },
      MITIGATION: {
        LABEL: 'Mitigation Actions',
        PLACEHOLDER: 'Measures taken to mitigate the incident...',
      },
    },
    ACTIONS: {
      REVIEW: 'Review Report',
      BACK: 'Back to Edit',
      SUBMIT: 'Submit to INCIBE-CERT',
    },
    SUCCESS_MESSAGE: 'Incident report submitted to INCIBE-CERT successfully',
    PREVIEW: {
      FROM: 'From',
      TO: 'To',
      SUBJECT: 'Subject',
      EMAIL_TO: 'incibe-cert@incibe.es',
      SUBJECT_TEXT: 'Security Incident Report',
      INCIDENT_DETAILS: 'Incident Details',
      NOT_PROVIDED: 'Not provided',
      UNCLASSIFIED: 'Unclassified',
    },
  },
}
